module.exports = __webpack_public_path__ + "assets/images/CADUNFIT5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CADUNFIT5.png
// module id = 1334
// module chunks = 1